import { pick } from 'lodash-es'
import MyEnum from '@/common/MyEnum'
import { enumValue } from '@/common/EnumValue'

export class APPEAL_STATUS extends MyEnum {
  static DRAFT = enumValue(0, '草稿')
  static UNREVIEWED = enumValue(2, '待受理')
  static REJECT = enumValue(3, '驳回')
  static ACCEPTANCE = enumValue(4, '处理中')
  static DEALING = enumValue(5, '确权中')
  static FINISHED = enumValue(6, '已完结')
  static CANCELEED = enumValue(7, '已取消')
}
export const appealStatusMap = APPEAL_STATUS.codeNameMap

export class APPEAL_TYPE extends MyEnum {
  static CP_APPEAL = enumValue(0, '版权投诉')
  static CP_NOTICE = enumValue(1, '版权认领')
}
export const appealTypeMap = APPEAL_TYPE.codeNameMap

export class LEVEL_ONE_APPEAL extends MyEnum {
  static TORT = enumValue(0, '侵权投诉')
  static OFFLINE = enumValue(1, '下架申请')
  static WHITE_LIST = enumValue(2, '白名单')
  static CP_NOTICE = enumValue(3, '版权认领')
}
export const levelOneAppealMap = LEVEL_ONE_APPEAL.codeNameMap

export class LEVEL_TWO_APPEAL extends MyEnum {
  static NONE = enumValue(0, '无')
  static STOLEN_TRACK = enumValue(2, '盗歌')
  static STOLEN_CP = enumValue(1, '录音信网')
  static COVER = enumValue(3, '词曲复制')
  static LM_CP = enumValue(9, '词曲信网')
  static OFFLINE = enumValue(4, '下架申请')
  static NOTICE_SONG_CP = enumValue(5, '录音版权')
  static NOTICE_LYRIC_CP = enumValue(6, '词版权')
  static NOTICE_MUSIC_CP = enumValue(7, '曲版权')
  static NOTICE_SONG_WITH_LM = enumValue(8, '录音附带词曲')
}
export const levelTwoAppealMap = LEVEL_TWO_APPEAL.codeNameMap

export class APPEAL_SUB_STATUS extends MyEnum {
  static UNREVIEWED = enumValue(0, '待确认')
  static DEALING = enumValue(1, '确权中')
  static FINISHED = enumValue(2, '已完成')
  static AUTO_DEALING = enumValue(3, '逾期自动处理')
}
export const appealSubStatusMap = APPEAL_SUB_STATUS.codeNameMap

export class APPEAL_TRACK_STATUS extends MyEnum {
  static UNREVIEWED = enumValue(0, '待受理')
  static VALID = enumValue(1, '有效')
  static COMPLAINT_MISTAKE = enumValue(2, '投诉有误')
  static RIGHT_FILE_INVALID = enumValue(3, '文件无效')
  static DEALING = enumValue(4, '确权中')
  static FINISHED = enumValue(5, '已完结')
  static CANCELEED = enumValue(6, '已取消')
}
export const appealTrackStatusMap = APPEAL_TRACK_STATUS.codeNameMap

export class MEDIA_TYPE extends MyEnum {
  static NONE = enumValue(-1, '无')
  static SONG = enumValue(0, '歌曲')
  static MV = enumValue(1, 'MV')
  static AUDIO_BOOK_TRACK = enumValue(2, '有声书单集')
  static AUDIO_BOOK_ALBUM = enumValue(3, '有声书专辑')
}
export const mediaTypeMap = MEDIA_TYPE.codeNameMap

// 把 appealPlatMap 变量改写成继承MyEnum的类
export class APPEAL_PLAT extends MyEnum {
  static NONE = enumValue(0, '无')
  static QQ_MUSIC = enumValue(1, 'QQ音乐')
  static KUGOU_MUSIC = enumValue(2, '酷狗音乐')
  static KUWO_MUSIC = enumValue(3, '酷我音乐')
  static LANREN_TINGSHU = enumValue(4, '懒人听书')
  static QUANMIN_KGE = enumValue(5, '全民K歌')
}
export const appealPlatMap = APPEAL_PLAT.codeNameMap

export class MATCH_STATUS extends MyEnum {
  static NO_RIGHT = enumValue(0, '匹配无权')
  static NO_FEEDBACK = enumValue(1, '重复版权方待确认')
  static WITHDRAW = enumValue(2, '申诉方撤诉')
  static GIVE_UP = enumValue(3, '重复版权方放弃权利')
  static REPEAT_RIGHT = enumValue(4, '重复版权方坚持权利')
  static REJECT = enumValue(5, '申诉方坚持驳回')
  static REPEAT = enumValue(6, '重复')
  static SUSPEND = enumValue(7, '申诉挂起')
  static APPEAL_WAIT = enumValue(8, '申诉方待确认')
  static REPEAT_REJECT = enumValue(9, '重复版权方坚持驳回')
  static APPEAL_RIGHT = enumValue(10, '申诉方坚持权利')
  static REPEAT_SUPPORT = enumValue(11, '支持重复版权方')
  static APPEAL_SUPPORT = enumValue(12, '支持申诉方')
  static APPEAL_GIVE_UP = enumValue(13, '申诉方放弃')
  static AUTO_DEALING = enumValue(14, '逾期自动处理')
  static SELF_SOLVE = enumValue(15, '双方自行解决')
  static LEGAL_EVALUATE = enumValue(16, '待法务评估')
  static LEGAL_EVALUATED = enumValue(17, '法务已评估')
  static REPEAT_AUDITING = enumValue(18, '重复版权方坚持审核中')
  static APPEAL_AUDITING = enumValue(19, '申诉方坚持审核中')
  static INVALID = enumValue(20, '作废')
}
export const matchStatusMap = MATCH_STATUS.codeNameMap

export const rightFileExtType = ['rar', 'zip', 'doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg', 'eml']
export const fileExtType = ['xlsx', 'xls']

// 维护 申诉类型-申诉一级场景-申诉二级场景 的关系
export const appealTypeLevelOneLevelTwoMap = {
  [APPEAL_TYPE.CP_APPEAL.code]: {
    [LEVEL_ONE_APPEAL.TORT.code]: [
      LEVEL_TWO_APPEAL.NONE.code,
      LEVEL_TWO_APPEAL.STOLEN_TRACK.code,
      LEVEL_TWO_APPEAL.STOLEN_CP.code,
      LEVEL_TWO_APPEAL.COVER.code,
      LEVEL_TWO_APPEAL.LM_CP.code,
    ],
    [LEVEL_ONE_APPEAL.OFFLINE.code]: [
      LEVEL_TWO_APPEAL.NONE.code,
      LEVEL_TWO_APPEAL.OFFLINE.code
    ],
    [LEVEL_ONE_APPEAL.WHITE_LIST.code]: [
      LEVEL_TWO_APPEAL.NONE.code
    ],
  },
  [APPEAL_TYPE.CP_NOTICE.code]: {
    [LEVEL_ONE_APPEAL.CP_NOTICE.code]: [
      LEVEL_TWO_APPEAL.NONE.code,
      LEVEL_TWO_APPEAL.NOTICE_SONG_CP.code,
      LEVEL_TWO_APPEAL.NOTICE_LYRIC_CP.code,
      LEVEL_TWO_APPEAL.NOTICE_MUSIC_CP.code,
      LEVEL_TWO_APPEAL.NOTICE_SONG_WITH_LM.code
    ],
  },
}

function isEmpty(val) {
  return val === undefined || val === null || val === ''
}
export function getLevelOneMap(type) {
  return isEmpty(type) ? levelOneAppealMap : pick(levelOneAppealMap, Object.keys(appealTypeLevelOneLevelTwoMap[type]))
}
export function getLevelTwoMap(type, levelOne) {
  return isEmpty(type) || isEmpty(levelOne) ? levelTwoAppealMap : pick(levelTwoAppealMap, appealTypeLevelOneLevelTwoMap[type][levelOne])
}

export class ONLINE_PLATFORM extends MyEnum {
  static TME = enumValue(1, 'TME')
  static QQ = enumValue(2, 'QQ音乐')
  static KG = enumValue(3, '酷狗音乐')
  static KW = enumValue(4, '酷我音乐')
}
export const onlinePlatformMap = ONLINE_PLATFORM.codeNameMap

export class AUTH_TYPE extends MyEnum {
  static NONE = enumValue(0, '无')
  static SIGN = enumValue(1, '签约')
}
export const authTypeMap = AUTH_TYPE.codeNameMap

export class RIGHT_FILE_TYPE extends MyEnum {
  static LINK = enumValue(1, '网盘链接')
  static FILE = enumValue(2, '文档文件')
}
export const rightFileTypeMap = RIGHT_FILE_TYPE.codeNameMap

export const platStatusMap = {
  1: '上架',
  0: '隐藏',
}
